import { useState } from "react";
import type { CorpusScanBadge, CorpusScanKey } from "./corpus_scan_contract";
import { useMissingFieldScan } from "./useMissingFieldScan";
import { useMissingSectionFilesScan } from "./useMissingSectionFilesScan";

/** Which scan is selected, and every scan's state. All scans are kept alive, so one keeps its result
 *  while another is selected. */
export function useCorpusScan() {
  const [selected, setSelected] = useState<CorpusScanKey | null>(null);
  const missingField = useMissingFieldScan();
  const missingSectionFiles = useMissingSectionFilesScan();

  const badges: Record<CorpusScanKey, CorpusScanBadge | null> = {
    missing_field: missingField.badge,
    missing_section_files: missingSectionFiles.badge,
  };

  return { selected, setSelected, badges, missingField, missingSectionFiles };
}
